<template>
  <form @submit.prevent="$refs.confirmationModalOpenBtn.click()">
    <div class="card-header">For Partner To Fill Up</div>
    <div class="card-body">
      <DefaultLoader v-if="isLoading"></DefaultLoader>
      <div v-else class="partner-form vr-form">
        <div class="row vr-form-row">
          <div class="form-group-container w-50">
            <div class="form-group">
              <label for="">Fare Per KM</label>
              <input
                type="number"
                v-model="formValue.fare_per_km"
                min="0"
                class="form-control"
                required
              />
            </div>
          </div>
          <div
            class="form-group-container w-50"
            v-if="requestRoute.modality !== 'pool'"
          >
            <div class="form-group">
              <label for="">Body Rent</label>
              <input
                type="number"
                v-model="formValue.body_rent"
                min="0"
                class="form-control"
                required
              />
            </div>
          </div>
          <div
            class="form-group-container w-25"
            v-if="requestRoute.modality === 'pool'"
          >
            <div class="form-group">
              <label for="">Daily Income</label>
              <p>
                {{
                  vehicleRequest.dailyIncomeWithShuttleBonus(
                    this.formValue.fare_per_km,
                    this.requestRoute.distance,
                    this.requestRoute.duty_days,
                    this.requestRoute.pick_up_times?.length,
                    this.formValue.shuttle_bonus_type,
                    this.formValue.shuttle_bonus
                  )
                }}
                TK
              </p>
            </div>
          </div>
          <div
            class="form-group-container w-25"
            v-if="requestRoute.modality === 'pool'"
          >
            <div class="form-group">
              <label for="">Weekly Income</label>
              <p>
                {{
                  vehicleRequest.weeklyIncomeWithShuttleBonus(
                    this.formValue.fare_per_km,
                    this.requestRoute.distance,
                    this.requestRoute.duty_days,
                    this.requestRoute.pick_up_times?.length,
                    this.formValue.shuttle_bonus_type,
                    this.formValue.shuttle_bonus
                  )
                }}
                TK
              </p>
            </div>
          </div>
        </div>
        <div
          class="row vr-form-row"
          v-if="requestRoute.modality === 'fleet-fixed'"
        >
          <div class="form-group-container w-50">
            <div class="form-group">
              <label for="">Lunch Allowance/Day</label>
              <input
                type="number"
                v-model="formValue.lunch_allowance_per_day"
                min="0"
                class="form-control"
                required
              />
            </div>
          </div>
        </div>
        <div
          class="row vr-form-row"
          v-if="requestRoute.modality === 'fleet-variable'"
        >
          <div class="form-group-container w-50">
            <div class="form-group">
              <label for="">Over Time/Hour Rate</label>
              <input
                type="number"
                v-model="formValue.overtime_payment_per_hour"
                min="0"
                class="form-control"
                required
              />
            </div>
          </div>
          <div class="form-group-container w-50">
            <div class="form-group">
              <label for="">Lunch Allowance/Day</label>
              <input
                type="number"
                v-model="formValue.lunch_allowance_per_day"
                min="0"
                class="form-control"
                required
              />
            </div>
          </div>
        </div>
        <div class="row vr-form-row" v-if="requestRoute.modality === 'pool'">
          <div class="form-group-container w-100">
            <div class="form-group">
              <label for="">Bonus</label>
              <div class="vr-checkbox-container">
                <template v-for="(bonusType, index) in bonusTypes" :key="index">
                  <div
                    class="vr-checkbox-group"
                    v-if="
                      bonusType.bonus_name === 'Shuttle Bonus' ||
                      bonusType.bonus_name === 'Completion Bonus'
                    "
                  >
                    <input
                      type="checkbox"
                      :value="bonusType.id"
                      v-model="formValue.bonus_types"
                    />
                    <span class="vr-checkbox-label">{{
                      bonusType.bonus_name
                    }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="row vr-form-row" v-if="requestRoute.modality === 'pool'">
          <div
            v-if="formValue.bonus_types.includes(bonusIds['Shuttle Bonus'])"
            class="form-group-container w-50"
          >
            <div class="form-group w-40">
              <label for=""></label>
              <select
                name=""
                v-model="formValue.shuttle_bonus_type"
                required
                class="form-select ignored-select-field"
              >
                <option value="PERCENTAGE">Percentange</option>
                <option value="FLAT">Flat</option>
              </select>
            </div>
            <div class="form-group w-60">
              <label for="">Shuttle Bonus</label>
              <input
                type="number"
                min="0"
                v-model="formValue.shuttle_bonus"
                required
                class="form-control"
              />
            </div>
          </div>
          <div
            v-if="formValue.bonus_types.includes(bonusIds['Completion Bonus'])"
            class="form-group-container w-50"
          >
            <div class="form-group">
              <div class="form-group">
                <label for="">Completion Bonus</label>
                <input
                  type="number"
                  min="0"
                  v-model="formValue.completion_bonus"
                  class="form-control"
                  required
                />
                <p
                  class="text-warning"
                  style="font-size: 12px; margin-top: 6px; margin-bottom: 0"
                >
                  <i class="bi bi-info-circle"></i> Completion bonus will be
                  calculated for both routes.
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="formValue.bonus_types.includes(bonusIds['Time Bonus'])"
            class="form-group-container w-50"
          >
            <div class="form-group w-50">
              <label for="">KM/Travel Time</label>
              <input
                type="number"
                min="0"
                v-model="formValue.travel_time_per_km"
                required
                class="form-control"
              />
            </div>
            <div class="form-group w-50">
              <label for="">Bonus/Minute</label>
              <input
                type="number"
                min="0"
                v-model="formValue.bonus_per_minute"
                required
                class="form-control"
              />
            </div>
          </div>
          <div
            v-if="formValue.bonus_types.includes(bonusIds['Others'])"
            class="form-group-container w-50"
          >
            <div class="form-group w-50">
              <label for="">Bonus Name</label>
              <input
                type="text"
                v-model="formValue.other_bonus_name"
                required
                class="form-control"
              />
            </div>
            <div class="form-group w-50">
              <label for="">Bonus Amount</label>
              <input
                type="number"
                min="0"
                v-model="formValue.other_bonus_amount"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div
          class="row vr-form-row"
          v-if="requestRoute.modality === 'fleet-variable'"
        >
          <div class="vr-checkbox-container">
            <div class="vr-checkbox-group">
              <input
                type="checkbox"
                v-model="formValue.same_as_expected_price"
                @change="fillDataFromExpectedPrice()"
              />
              <span class="vr-checkbox-label">Same as expected price</span>
            </div>
          </div>
        </div>
        <div
          class="row vr-form-row"
          v-if="
            vehicleRequest.returnRoute(
              requestDetails.trip_request_routes,
              requestRoute.id
            )
          "
        >
          <div class="vr-checkbox-container">
            <div class="vr-checkbox-group">
              <input
                type="checkbox"
                v-model="formValue.same_price_for_return_route"
              />
              <span class="vr-checkbox-label"
                >Assign same TR Price for return route-
                <b>{{
                  vehicleRequest.returnRoute(
                    requestDetails.trip_request_routes,
                    requestRoute.id
                  ).route_name
                }}</b></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button
        type="button"
        class="btn btn-cancel"
        v-if="requestRoute.fare_per_km"
        @click="$emit('cancelTRPriceUpdate')"
      >
        Cancel
      </button>
      <button class="btn btn-primary">Proceed</button>
    </div>
  </form>

  <!-- Confirmation Modal -->
  <button
    ref="confirmationModalOpenBtn"
    style="display: none"
    data-bs-toggle="modal"
    :data-bs-target="`#confirmationModal${requestRoute.id}`"
  ></button>
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      :id="`confirmationModal${requestRoute.id}`"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ requestRoute.route_name }}, {{ requestDetails.trip_code }}
            </h5>
            <button
              type="button"
              class="btn-close"
              ref="modalCloseBtn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="partner-modal-section"
              v-if="requestRoute.modality === 'pool'"
            >
              <div class="partner-modal-info">
                <div class="info-content">
                  <div class="info-row">
                    <div class="income-info">
                      <div>
                        <h5 class="info-title">Daily Income</h5>
                        <p class="info-text">
                          Shuttle bonus included. Completion bonus not included.
                        </p>
                      </div>
                      <span class="price-text"
                        >{{
                          vehicleRequest.dailyIncomeWithShuttleBonus(
                            this.formValue.fare_per_km,
                            this.requestRoute.distance,
                            this.requestRoute.duty_days,
                            this.requestRoute.pick_up_times?.length,
                            this.formValue.shuttle_bonus_type,
                            this.formValue.shuttle_bonus
                          )
                        }}
                        TK</span
                      >
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="income-info">
                      <div>
                        <h5 class="info-title">Weekly Income</h5>
                        <p class="info-text">
                          Shuttle bonus included. Completion bonus not included.
                        </p>
                      </div>
                      <span class="price-text"
                        >{{
                          vehicleRequest.weeklyIncomeWithShuttleBonus(
                            this.formValue.fare_per_km,
                            this.requestRoute.distance,
                            this.requestRoute.duty_days,
                            this.requestRoute.pick_up_times?.length,
                            this.formValue.shuttle_bonus_type,
                            this.formValue.shuttle_bonus
                          )
                        }}
                        TK</span
                      >
                    </div>
                  </div>
                  <!-- <div class="info-row">
                    <div class="income-info">
                      <div>
                        <h5 class="info-title">Weekly Income</h5>
                        <p class="info-text">
                          Shuttle bonus and Completion bonus included.
                        </p>
                      </div>
                      <span class="price-text"
                        >{{
                          vehicleRequest.weeklyIncomeWithShuttleAndCompletionBonus(
                            this.formValue.fare_per_km,
                            this.requestRoute.distance,
                            this.requestRoute.duty_days,
                            this.requestRoute.pick_up_times?.length,
                            this.formValue.shuttle_bonus_type,
                            this.formValue.shuttle_bonus,
                            this.formValue.completion_bonus
                          )
                        }}
                        TK</span
                      >
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="partner-modal-section">
              <div class="partner-modal-info">
                <div class="info-content">
                  <div class="row info-row">
                    <div class="col-sm-4 bonus-cell">
                      <div>
                        <h5 class="info-title">Fare Per KM</h5>
                        <p>{{ this.formValue.fare_per_km }} TK</p>
                      </div>
                    </div>
                    <template v-if="requestRoute.modality === 'fleet-fixed'">
                      <div class="col-sm-4 bonus-cell">
                        <div>
                          <h5 class="info-title">Body Rent</h5>
                          <p>{{ this.formValue.body_rent }} TK</p>
                        </div>
                      </div>
                      <div class="col-sm-4 bonus-cell">
                        <div>
                          <h5 class="info-title">Lunch Allowance/Day</h5>
                          <p>{{ this.formValue.lunch_allowance_per_day }} TK</p>
                        </div>
                      </div>
                    </template>
                    <template
                      v-else-if="requestRoute.modality === 'fleet-variable'"
                    >
                      <div class="col-sm-4 bonus-cell">
                        <div>
                          <h5 class="info-title">Body Rent</h5>
                          <p>{{ this.formValue.body_rent }} TK</p>
                        </div>
                      </div>
                      <div class="col-sm-4 bonus-cell">
                        <div>
                          <h5 class="info-title">Over Time/Hour Rate</h5>
                          <p>
                            {{ this.formValue.overtime_payment_per_hour }} TK
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-4 bonus-cell">
                        <div>
                          <h5 class="info-title">Lunch Allowance/Day</h5>
                          <p>{{ this.formValue.lunch_allowance_per_day }} TK</p>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <template
                        v-for="(bonusId, bonusIndex) in this.formValue
                          .bonus_types"
                        :key="bonusIndex"
                      >
                        <template v-if="bonusObj[bonusId]">
                          <template
                            v-if="
                              bonusObj[bonusId].bonus_name === 'Shuttle Bonus'
                            "
                          >
                            <div class="col-sm-4 bonus-cell">
                              <h5 class="info-title">Shuttle Bonus</h5>
                              <p>
                                {{ this.formValue.shuttle_bonus }}
                                {{
                                  this.formValue.shuttle_bonus_type ===
                                  'PERCENTAGE'
                                    ? '%'
                                    : 'TK'
                                }}
                              </p>
                            </div>
                          </template>
                          <template
                            v-if="
                              bonusObj[bonusId].bonus_name ===
                              'Completion Bonus'
                            "
                          >
                            <div class="col-sm-4 bonus-cell">
                              <h5 class="info-title">Completion Bonus</h5>
                              <p>{{ this.formValue.completion_bonus }} TK</p>
                              <p class="text-warning" style="font-size: 12px">
                                <i class="bi bi-info-circle"></i> Completion
                                bonus will be calculated for both routes.
                              </p>
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Close
            </button>
            <button
              v-if="isLoading"
              class="btn btn-primary"
              type="button"
              disabled
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
            <button v-else class="btn btn-primary" @click="setTRPrice">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import http from '@/config/axios';
import { vehicleRequest } from '../../../store/vehicleRequest/vehicleRequest';

export default {
  props: ['bonusTypes', 'requestDetails', 'requestRoute'],
  data() {
    return {
      isLoading: false,
      formValue: {
        fare_per_km: null,
        bonus_types: [],
        shuttle_bonus_type: 'PERCENTAGE',
        shuttle_bonus: null,
        completion_bonus: null,
        travel_time_per_km: null,
        bonus_per_minute: null,
        other_bonus_name: '',
        other_bonus_amount: null,
        same_price_for_return_route: false,
        same_as_expected_price: false,
        body_rent: null,
        overtime_payment_per_hour: null,
        lunch_allowance_per_day: null
      },
      bonusIds: {},
      bonusObj: {},
      vehicleRequest
    };
  },
  mounted() {
    this.mapBonus();
    this.fillFormValue();
    this.fillConditionFromExpectedPrice();
  },
  watch: {
    bonusTypes: {
      handler() {
        this.mapBonus();
        this.fillFormValue();
      },
      deep: true
    },
    requestRoute: {
      handler() {
        this.fillFormValue();
      },
      deep: true
    },
    'formValue.bonus_types': {
      handler() {
        this.refreshBonusFields();
      },
      deep: true
    },
    'formValue.fare_per_km': {
      handler() {
        this.validateSameAsExpectedPriceCondition();
      }
    },
    'formValue.body_rent': {
      handler() {
        this.validateSameAsExpectedPriceCondition();
      }
    },
    'formValue.overtime_payment_per_hour': {
      handler() {
        this.validateSameAsExpectedPriceCondition();
      }
    },
    'formValue.lunch_allowance_per_day': {
      handler() {
        this.validateSameAsExpectedPriceCondition();
      }
    }
  },
  methods: {
    fillFormValue() {
      this.resetFormValues();
      if (this.requestRoute.fare_per_km) {
        this.formValue.fare_per_km = this.requestRoute.fare_per_km;
      }
      if (this.requestRoute.body_rent) {
        this.formValue.body_rent = this.requestRoute.body_rent;
      }
      if (this.requestRoute.overtime_payment_per_hour) {
        this.formValue.overtime_payment_per_hour =
          this.requestRoute.overtime_payment_per_hour;
      }
      if (this.requestRoute.lunch_allowance_per_day) {
        this.formValue.lunch_allowance_per_day =
          this.requestRoute.lunch_allowance_per_day;
      }

      this.requestRoute.trip_request_bonuses.forEach((bonus) => {
        this.formValue.bonus_types.push(bonus.bonus_id);
        if (this.bonusObj[bonus.bonus_id]) {
          if (this.bonusObj[bonus.bonus_id].bonus_name === 'Shuttle Bonus') {
            this.formValue.shuttle_bonus_type = bonus.type.toUpperCase();
            this.formValue.shuttle_bonus = bonus.base_bonus;
          } else if (
            this.bonusObj[bonus.bonus_id].bonus_name === 'Completion Bonus'
          ) {
            this.formValue.completion_bonus = bonus.base_bonus;
          }
        }
      });
    },
    fillConditionFromExpectedPrice() {
      if (
        !this.requestRoute.fare_per_km &&
        !this.requestRoute.body_rent &&
        !this.requestRoute.overtime_payment_per_hour &&
        !this.requestRoute.lunch_allowance_per_day
      ) {
        this.formValue.same_as_expected_price = true;
        this.fillDataFromExpectedPrice();
      }
    },
    fillDataFromExpectedPrice() {
      if (this.formValue.same_as_expected_price) {
        this.formValue.fare_per_km = this.requestRoute.expected_fare_per_km;
        this.formValue.body_rent = this.requestRoute.expected_body_rent;
        this.formValue.overtime_payment_per_hour =
          this.requestRoute.expected_overtime_payment_per_hour;
        this.formValue.lunch_allowance_per_day =
          this.requestRoute.expected_lunch_allowance_per_day;
      } else {
        this.fillFormValue();
      }
    },
    validateSameAsExpectedPriceCondition() {
      if (
        this.formValue.fare_per_km === this.requestRoute.expected_fare_per_km &&
        this.formValue.body_rent === this.requestRoute.expected_body_rent &&
        this.formValue.overtime_payment_per_hour ===
          this.requestRoute.expected_overtime_payment_per_hour &&
        this.formValue.lunch_allowance_per_day ===
          this.requestRoute.expected_lunch_allowance_per_day
      ) {
        this.formValue.same_as_expected_price = true;
      } else {
        this.formValue.same_as_expected_price = false;
      }
    },
    mapBonus() {
      this.bonusTypes.forEach((element) => {
        this.bonusIds[element.bonus_name] = element.id;
        this.bonusObj[element.id] = element;
      });
    },
    refreshBonusFields() {
      this.bonusTypes.forEach((bonusType) => {
        if (
          !this.formValue.bonus_types.includes(bonusType.id) &&
          this.bonusObj[bonusType.id]
        ) {
          if (this.bonusObj[bonusType.id].bonus_name === 'Shuttle Bonus') {
            this.formValue.shuttle_bonus_type = 'PERCENTAGE';
            this.formValue.shuttle_bonus = null;
          } else if (
            this.bonusObj[bonusType.id].bonus_name === 'Completion Bonus'
          ) {
            this.formValue.completion_bonus = null;
          } else if (this.bonusObj[bonusType.id].bonus_name === 'Time Bonus') {
            this.formValue.travel_time_per_km = null;
            this.formValue.bonus_per_minute = null;
          } else if (this.bonusObj[bonusType.id].bonus_name === 'Others') {
            this.formValue.other_bonus_name = '';
            this.formValue.other_bonus_amount = null;
          }
        }
      });
    },
    makeBonusData() {
      let bonuses = [];
      this.formValue.bonus_types.forEach((bonusTypeId) => {
        let bonus = this.bonusObj[bonusTypeId];
        if (bonus && bonus.bonus_name === 'Shuttle Bonus') {
          bonuses.push({
            bonus_id: bonus.id,
            type: this.formValue.shuttle_bonus_type,
            base_bonus: this.formValue.shuttle_bonus
          });
        } else if (bonus && bonus.bonus_name === 'Completion Bonus') {
          bonuses.push({
            bonus_id: bonus.id,
            base_bonus: this.formValue.completion_bonus
          });
        } else if (bonus && bonus.bonus_name === 'Time Bonus') {
          bonuses.push({
            bonus_id: bonus.id,
            travel_time_per_km: this.formValue.travel_time_per_km,
            bonus_per_minute: this.formValue.bonus_per_minute
          });
        } else if (bonus && bonus.bonus_name === 'Others') {
          bonuses.push({
            bonus_id: bonus.id,
            bonus_name: this.formValue.other_bonus_name,
            base_bonus: this.formValue.other_bonus_amount
          });
        }
      });
      return bonuses;
    },
    resetFormValues() {
      this.formValue = {
        fare_per_km: null,
        bonus_types: [],
        shuttle_bonus_type: 'PERCENTAGE',
        shuttle_bonus: null,
        completion_bonus: null,
        travel_time_per_km: null,
        bonus_per_minute: null,
        other_bonus_name: '',
        other_bonus_amount: '',
        same_price_for_return_route: false,
        same_as_expected_price: false,
        body_rent: null,
        overtime_payment_per_hour: null,
        lunch_allowance_per_day: null
      };
    },
    setTRPrice() {
      this.isLoading = true;
      let bonusData = this.makeBonusData();
      let payload = {
        fare_per_km: this.formValue.fare_per_km,
        bonuses: bonusData
      };

      if (this.requestRoute.modality !== 'pool') {
        payload.body_rent = this.formValue.body_rent;
        payload.lunch_allowance_per_day =
          this.formValue.lunch_allowance_per_day;
      }
      if (this.requestRoute.modality === 'fleet-variable') {
        payload.overtime_payment_per_hour =
          this.formValue.overtime_payment_per_hour;
      }

      http
        .patch(
          `v2/partners/triprequestroutes/${
            this.requestRoute.id
          }?trip_requests_id=${
            this.requestRoute.trip_requests_id
          }&assign_same_price_for_other_routes=${
            this.formValue.same_price_for_return_route ? 1 : 0
          }`,
          payload
        )
        .then((response) => {
          this.isLoading = false;
          this.resetFormValues();
          this.$refs.modalCloseBtn.click();
          this.$emit('refreshData');
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success!',
            text: response.data?.message
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.vr-form-row {
}
.vr-form {
}
.vr-form .form-group-container {
  margin-bottom: 24px;
}
.vr-form .form-group-container .form-group {
  float: left;
  width: 100%;
  padding: 0 12px;
}
.vr-form .form-group-container .form-group:last-child {
  padding-right: 0;
}
.vr-form .form-group-container .form-group:first-child {
  padding-left: 0;
}
.vr-form .form-group-container .form-group label {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 12px;
  min-height: 15px;
}
.vr-form .form-group-container .form-group .ignored-select-field {
  border: 1px solid #d5d5d5;
  color: #d5d5d5;
}
.vr-form .form-group-container .form-group select:focus {
  box-shadow: none;
  border: 1px solid #652f8f;
  color: #652f8f;
}
.vr-checkbox-container {
}
.vr-checkbox-group {
  float: left;
  margin-right: 8px;
  display: flex;
  align-items: center;
}
.vr-checkbox-group .vr-checkbox-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.card-footer {
  display: flex;
  justify-content: end;
}

/* Confirmation Modal Design Start */
.partner-modal-info .info-row {
  padding: 8px 0;
  color: #121212;
}
.partner-modal-info .info-row:first-child {
  padding-top: 0;
}
.partner-modal-info .info-row:last-child {
  padding-bottom: 0;
}
.partner-modal-info .info-row .income-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.partner-modal-info .info-row h5 {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 14px;
}
.partner-modal-info .info-row p {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}
.partner-modal-info .info-row .info-text {
  margin-bottom: 0;
  font-weight: 300;
  font-size: 14px;
  line-height: 14px;
}
.price-text {
  display: flex;
  justify-content: end;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #652f8f;
}
.partner-modal-info .info-row .bonus-cell {
  margin-top: 16px;
}
.partner-modal-info .info-row .bonus-cell:nth-child(1),
.partner-modal-info .info-row .bonus-cell:nth-child(2),
.partner-modal-info .info-row .bonus-cell:nth-child(3) {
  margin-top: 0;
}
/* Confirmation Modal Design End */

.w-25 {
  width: 25% !important;
}
.w-50 {
  width: 50% !important;
}
.w-40 {
  width: 40% !important;
}
.w-60 {
  width: 60% !important;
}
.w-100 {
  width: 100% !important;
}
@media only screen and (max-width: 768px) {
  .w-25 {
    width: 100% !important;
  }
  .w-50 {
    width: 100% !important;
  }
  .w-40 {
    width: 100% !important;
  }
  .w-60 {
    width: 100% !important;
  }
}
</style>
